const TIMEOUT_IN_MINUTES = 30;
export const DEFAULT_TIMEOUT = 1000 * 60 * TIMEOUT_IN_MINUTES;

export const formatInactiveMessage = (i18n) =>
  i18n.t(`Du er blevet logget ud grundet ${TIMEOUT_IN_MINUTES} minutters inaktivitet.`);
